import { Controller } from '@hotwired/stimulus';

export default class ToggleAllCheckboxesController extends Controller {
    static targets = ["trigger", "checkbox", "hiddenCheckbox"]
    static values = ["set"]

    triggerTargetConnected(trigger) { {
        // console.log("trigger " + trigger.dataset);
        trigger.addEventListener("change", this.toggleAll)
    }}

    toggleAll = (evt) => {
        const trigger = evt.target;
        const set = trigger.dataset.toggleAllSetValue
        // console.log("toggleAll ", set, trigger);
        this.checkboxTargets.forEach((checkbox) => {
            // console.log("checkbox toggle ", set, checkbox.dataset.toggleAllSetValue);
            if (checkbox.dataset.toggleAllSetValue === set) {
                checkbox.checked = trigger.checked
                this.triggerInputEvent(checkbox)
            }
        })
        this.hiddenCheckboxTargets.forEach((hiddenCheckbox) => {
            // console.log("checkbox toggle ", set, checkbox.dataset.toggleAllSetValue);
            if (hiddenCheckbox.dataset.toggleAllSetValue === set) {
                hiddenCheckbox.value = trigger.checked
                this.triggerInputEvent(hiddenCheckbox)
            }
        })
    }

    triggerInputEvent(checkbox) {
        const event = new Event("input", {bubbles: false, cancelable: true});

        checkbox.dispatchEvent(event);
    }
}
